module.exports = __webpack_public_path__ + "static/banner-moc-1-1-15641130f4a5c2c30e27b6938eed5770.png";